import { inputValidator, validateGln, validateOrgno } from "../../../../helpers/inputVaildator";

export const invoiceFieldValidator = (input, type, data, countryCode = null, company = true) => {
    let isValid = true
    switch (type) {
        case "Name":
            if (data.required && /* input.toString().replace(/\s/g, '').length && */ input.length === 0) isValid = false;
            break;
        case "Address1":
            if (data.required && /* input.toString().replace(/\s/g, '').length && */ input.length === 0) isValid = false;
            break;
        case "Address2":
            isValid = true;
            break;
        case "Zip":
            if (data.required && /* input.toString().replace(/\s/g, '').length && */ input.length === 0) isValid = false;
            break;
        case "City":
            if (data.required && /* input.toString().replace(/\s/g, '').length && */ input.length === 0) isValid = false;
            break;
        case "OrgNo":
            if (data.required && /* input.toString().replace(/\s/g, '').length && */ input.length === 0) isValid = false;
            else if (input.length > 0) {
                isValid = validateOrgno(input, countryCode, company);
            }
            break;
        case "GLN":
            if (data.required/*  && input.toString().replace(/\s/g, '').length */ && input.length === 0) isValid = false;
            else if (input.length > 0) {
                isValid = validateGln(input);
            }
            break;
        case "Email":
            if (data.required && /* input.toString().replace(/\s/g, '').length &&  */input.length === 0) isValid = false;
            else if (input.length > 0) {
                isValid = inputValidator(input, 'email');
            }
            break;
        case "CountryCode":
            if (data.readOnly) isValid = true;
            else if (data.required/*  && input.toString().replace(/\s/g, '').length */ && input.length === 0) isValid = false;
            break;
        case "Telephone1":
            if (data.required /* && input.toString().replace(/\s/g, '').length */ && input.length === 0) isValid = false;
            break;
        default:
            break;
    }
    return isValid;
}
